import { SR_API_ACTION_FLOOR_PLAN_GET_SHOW_UNIT } from 'api/actionTypes';

export default async function getShowUnit({ state, apiClient }, { floorPlanId }) {
  const statePath = ['floorPlans', 'showUnitsByFloorPlanId', floorPlanId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_FLOOR_PLAN_GET_SHOW_UNIT,
    state: state,
    payload: {
      floorPlanId,
    },
    onSuccess(showUnit) {
      state.set(statePath, showUnit);
    },
  });
}
